// extracted by mini-css-extract-plugin
module.exports = {"skillSection":"SkillsSection_skillSection__1vAll","skillCat":"SkillsSection_skillCat__3Km92"};